import React from 'react';
import styled from 'styled-components';

function ToggleButton(props) {
  const { open, setOpen } = props;

  return (
    <StyledToggleButton
      open={open}
      onClick={() => setOpen(!open)}
      aria-label="Menü öffnen"
    >
      <div />
      <div />
      <div />
    </StyledToggleButton>
  );
}

const StyledToggleButton = styled.button`
  background-color: transparent;
  border: none;
  box-shadow: none;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: 14px;
  justify-content: space-between;
  margin: 0;
  padding: 21px;
  width: 18px;
  z-index: 2;
  box-sizing: content-box;

  &:focus {
    outline: none;
  }

  div {
    background-color: #464949;
    border-radius: 1px;
    height: 2px;
    width: 100%;
  }

  @media (min-width: 979px) {
    display: none;
  }
`;

export default ToggleButton;
